import { combineReducers } from "redux";
import authReducer from "./reducers/authReducer";
import settingsReducer from "./reducers/settingsReducer";
import facilitatorReducer from "./reducers/facilitatorReducer";
const rootReducer = combineReducers({ authReducer, settingsReducer, facilitatorReducer });

export default rootReducer;
